// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type { AuthResponse, AuthSessionHint, LoginInput, UserDto } from '@app/contracts';

export const login = (input: LoginInput): Promise<AuthResponse> =>
  apiAxios<AuthResponse>({ url: '/api/v1/auth/login', method: 'POST', data: input });

export const fetchAuthSessionHint = (): Promise<AuthSessionHint> =>
  apiAxios<AuthSessionHint>({ url: '/api/v1/auth/session-hint', method: 'GET' });

export const refresh = (): Promise<AuthResponse> =>
  apiAxios<AuthResponse>({ url: '/api/v1/auth/refresh', method: 'POST' });

export const logout = (): Promise<void> =>
  apiAxios<void>({ url: '/api/v1/auth/logout', method: 'POST' });

export const fetchMe = (): Promise<UserDto> =>
  apiAxios<UserDto>({ url: '/api/v1/auth/me', method: 'GET' });
